import { useState } from "react";
import { ButtonContent } from "../global/boton/ButtonContent";

function HeroSection({
  bgImg,
  bgImg1,
  bgImg2,
  bgImg3,
  title,
  texts
}) {

  const BgImages = [bgImg, bgImg1, bgImg2, bgImg3];

  // Estado para el idioma (inglés por defecto)
  const [language, setLanguage] = useState("en");

  // Contenido en Español
  const contentES = {
    greeting: "Hola Familias, mi nombre es Martha y proporciono un ambiente familiar, seguro, amoroso y nutritivo de cuidado infantil en Yonkers, NY. Para niños de 3 meses a 12 años...",
    features: [
      "Proveedor con Licencia aprobada",
      "Entorno Bilingüe (Inglés y Español)",
      "Seguridad y bienestar emocional",
      "Aprendizaje a través del juego y las actividades diarias",
      "Horarios 6:30 AM - 6:30 PM",
      "Tenemos Pampers Gratis por 2 semanas",
      "Tenemos descuentos cuando son hermanos.",
      "Ofrecemos comidas halal."

    ],
    passion: "Me apasiona cuidar a los niños y crear un lugar cálido donde puedan aprender, crecer y sentirse amados cada día.",
    availability: "Actualmente tenemos lugares disponibles. Siéntete libre para contactarnos y hacer tus preguntas.",
    infoText: "Para información",
    buttonText: "Contáctanos"
  };

  // Contenido en Inglés (predeterminado)
  const contentEN = {
    greeting: "Hello Families, my name is Martha and I provide a family-oriented, safe, loving, and nurturing childcare environment in Yonkers, NY. For children from 3 months to 12 years old...",
    features: [
      "Licensed Approved Provider",
      "Bilingual Environment (English and Spanish)",
      "Safety and emotional well-being",
      "Learning through play and daily activities",
      "Hours: 6:30 AM - 6:30 PM",
      "We're giving away free Pampers for 2 weeks",
      "We offer discounts for siblings.",
      " We offer halal meals."
    ],
    passion: "I am passionate about caring for children and creating a warm place where they can learn, grow, and feel loved every day.",
    availability: "We currently have spots available. Feel free to contact us with any questions.",
    infoText: "For information",
    buttonText: "Contact Us"
  };

  // Seleccionar contenido según idioma
  const content = language === "es" ? contentES : contentEN;

  return (
    <div className="flex w-full bg-2">
      <div className="pic-wrapper w-full h-screen">
        {BgImages.map((item, index) => (
          <figure
            key={index}
            className={`pic-${index + 1}`}
            style={{ background: `url("${item}")` }}
          />
        ))}

        <div className="z-[4] relative w-full h-full flex md:justify-start justify-center md:pb-[170px] md:pt-[200px] pt-[180px] pb-[100px]">
          <div className="md:w-1/2 w-[90%] md:ml-32">

            {/* Language Toggle - Tabs de idioma */}
            <div className="flex items-center gap-2 mb-6 bg-white/10 backdrop-blur-sm rounded-lg p-1 w-fit mx-auto md:mx-0 border border-white/20">
              <button
                onClick={() => setLanguage("en")}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-300 ${language === "en"
                    ? "bg-white/20 text-white shadow-lg"
                    : "text-gray-300 hover:text-white hover:bg-white/10"
                  }`}
              >
                🇺🇸 English
              </button>
              <button
                onClick={() => setLanguage("es")}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-300 ${language === "es"
                    ? "bg-white/20 text-white shadow-lg"
                    : "text-gray-300 hover:text-white hover:bg-white/10"
                  }`}
              >
                🇪🇸 Español
              </button>
            </div>

            {/* Title - Manteniendo la estructura original con {title} */}
            <h1 className="text-white text-center md:text-start text-[35px] md:text-[50px]">
              {title}
            </h1>

            {/* Description */}
            <p className="text-white text-center md:text-start">
              {content.greeting}
              <br />
              <ul>
                {content.features.map((feature, index) => (
                  <li key={index}>✅ {feature}</li>
                ))}
              </ul>
              <br />
              {content.passion}
              <br />
              {content.availability}
              <br />
              <span className="text-white font-bold">
                {content.infoText}: <a href="tel:9293034988" className="text-white hover:underline">929-303-4988</a>
              </span>
              <br />
              <span className="text-white font-bold">
                Email: <a href="mailto:marthawilliamsa38@gmail.com" className="text-white hover:underline">marthawilliamsa38@gmail.com</a>
              </span>
            </p>

            {/* Button */}
            <div className="w-full flex justify-center md:justify-start py-5">
              <ButtonContent btnStyle="five" text={content.buttonText} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeroSection;
